import { NotificationRuleT } from 'app/pages/NotificationsPage/NotificationsSettings';
import { useTranslation } from 'react-i18next';

export const getDisplayPhraseForNotifications = (args: NotificationRuleT) => {
  const { t } = useTranslation();
  const v_name =
    args.vessel.registryData !== undefined && args.vessel.registryData.name !== undefined
      ? args.vessel.registryData.name + ' '
      : '';
  const v_mmsi = 'MMSI ' + (args.vessel.mmsi !== undefined ? args.vessel.mmsi : args.vessel);
  const v_imo =
    args.vessel.registryData !== undefined && args.vessel.registryData?.imo !== undefined
      ? `${' IMO ' + args.vessel.registryData.imo}`
      : '';
  const vessel = Object.keys(args.vessel).length !== 0 ? t('Vessel') + ' ' + v_name + v_mmsi + v_imo : t('AnyVessel');

  const port =
    args.port !== undefined && args.port.cityName !== undefined
      ? t('Port') + ' ' + args.port.name + ' (' + args.port.un + ' ' + args.port.locode + ')'
      : t('AnyPort');

  const area_name = args.area !== undefined && args.area.name !== undefined ? args.area.name : args.area;

  const area = typeof area_name === 'string' && area_name.length > 0 ? t('Area') + ' ' + area_name : t('AnyArea');

  let desc = '';

  if (args.eventType === 'AREA_IN' || args.eventType === 'AREA_OUT') {
    desc = vessel + ' — ' + area;
  } else if (args.eventType === 'ANCHORAGE_RAISE_THE_ANCHOR' || args.eventType === 'ANCHORAGE_LOWER_THE_ANCHOR') {
    desc = vessel + ' — ' + t('AnyAnchorage');
  } else if (args.eventType === 'TARGET_SAFETY') {
    desc = Object.keys(args.vessel).length !== 0 ? vessel : t('FleetLabel');
  } else {
    desc = vessel + ' — ' + port;
  }

  return <>{desc}</>;
};
